<template>
    <v-app id="inspire">
        <div id="app">
            <router-view></router-view>

            <ProgressDialog></ProgressDialog>
            <ErrorDialog></ErrorDialog>
            <Snackbar></Snackbar>
        </div>
    </v-app>
</template>

<script>
    import ProgressDialog from "./components/dialogs/ProgressDialog";
    import ErrorDialog from "@/components/dialogs/ErrorDialog";
    import Snackbar from "@/components/Snackbar";

    export default {
        components: {
            ErrorDialog,
            ProgressDialog,
            Snackbar
        }
    }
</script>

<style lang="scss">

@font-face {
  font-family: "Roboto";
  src: url("~@/assets/font/Roboto-Bold.ttf");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url("~@/assets/font/Roboto-Medium.ttf");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: url("~@/assets/font/Roboto-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}

$body-font-family: "Roboto", sans-serif;
</style>
